import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {
    #config: Object = null;

    initialize() {
        return new Promise((resolve) => {
            this.#config = {
                apiUrl: environment.apiUrl,
                envSuffix: environment.envSuffix,
            };
            resolve(true);
        });
    }

    logObject(o: any) {
        for (var propName in o) {
            console.log(propName, o[propName]);
        }
    }

    get(key: string): any {
        return this.#config[key];
    }
}

export const enum AppConfigKeys {
    ApiUrl = 'apiUrl',
    EU = 'eu',
    EnvSuffix = 'envSuffix',
    Beta = 'beta',
}
